import { useQuery } from "convex/react"
import { api } from "../../../../convex/_generated/api"

export function useCompanyChromeCapabilities(enabled: boolean) {
  const company = useQuery(api.companies.myCompany, enabled ? {} : "skip")
  if (!enabled || company === null) return null
  if (company === undefined) return undefined
  return company.capabilities
}
